import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { storesApi } from "../../api";

export interface IAboutUs {
    description: string;
    sections: Array<{
        id: number;
        title: string;
        description: string;
    }>;
    images: {
        src: string | null;
        type: string;
    };
}

type AboutUsState = {
    loading: boolean;
    error: null | string;
    aboutUs: null | IAboutUs;
}

const initialState: AboutUsState = {
    error: null,
    loading: false,
    aboutUs: null,
}

export const fetchAboutUs = createAsyncThunk(
    'aboutUs/fetchAboutUs',
    async (_, { rejectWithValue }) => {
        try {
            const res = await storesApi.getAboutUs();
            return res.data;
        } catch (error: any) {
            return rejectWithValue(error.response?.data || 'Ошибка сервера');
        }
    }
);

const aboutUsSlice = createSlice({
    name: 'aboutUs',
    initialState,
    reducers: {},
    extraReducers: ({ addCase }) => {
        addCase(fetchAboutUs.pending, (state) => {
            state.loading = true;
            state.error = null;
        });
        addCase(fetchAboutUs.fulfilled, (state, action) => {
            state.aboutUs = action.payload;
            state.loading = false;
        });
        addCase(fetchAboutUs.rejected, (state) => {
            state.loading = false;
            state.error = 'Ошибка сервера!';
        });
    },
});

export default aboutUsSlice.reducer;

